import * as yup from "yup";
import { ContactOption } from "./ContactOption.csharp";

export interface ContactFormDataErrors {
  required: string;
  phone: string;
}

export const contactFormDataValidationSchema = (
  error: ContactFormDataErrors,
  contactOptions: ContactOption[]
) =>
  yup
    .object()
    .shape({
      name: yup.string().required(error.required),
      optionDisplayName: yup
        .string()
        .test("required", error.required, (value) => !!value),
      subOptionDisplayName: yup.string().when("optionDisplayName", {
        is: (value: string) => {
          // Check if the selected option has sub-options
          const selectedOption = contactOptions.find(
            (option) => option.displayName === value
          );
          return selectedOption && selectedOption.contactOptions.length > 0;
        },
        then: yup.string().required(error.required),
        otherwise: yup.string().notRequired(),
      }),
      phoneNumber: yup
        .string()
        .test("required", error.required, (value) => !!value)
        .test(
          "type",
          error.phone,
          (value) => value != undefined && !isNaN(Number(value))
        )
        .test(
          "length",
          error.phone,
          (value) => value != undefined && value.length >= 8
        ),
    })
    .required();
